export const CREATE_NO_DEPT_PROJECT_LIST_ROLE_PREFIX_URL =
  '/create-no-dept-project-list-role'
